import React, { Component } from "react";
import {
  CardDeck,
  Row,
  Col,
  Tabs,
  Tab,
  Container,
  Alert,
  Badge,
} from "react-bootstrap";
import { connect } from "react-redux";

import Layout from "../layout";
import TrainingCard from "./TrainingCard";
import ErrorModal from "../error/ErrorModal";
import LoadingAnimation from "../loading";
import ZoomInfo from "./ZoomInfo";
import { getTraining } from "../../actions";
class Training extends Component {
  componentDidMount() {
    if (!this.props.training) {
      this.props.getTraining(this.props.auth.jwt, this.props.auth.username);
    }
  }

  buildCardDeck(items) {
    const cards = [];
    items.forEach((card, i) => {
      if (
        card.szTrainingClassName &&
        !card.szTrainingClassName.toLowerCase().includes("online")
      )
        cards.push(<TrainingCard key={i} class={card} index={i} />);
    });
    const deck = [];
    const chunk = 1;
    for (let i = 0, k = 0; i <= cards.length - 1; i += chunk, k++) {
      deck.push(<CardDeck key={k}>{cards.slice(i, i + chunk)}</CardDeck>);
    }
    return cards.length > 0 ? (
      deck
    ) : (
      <Alert variant="info">
        <Alert.Heading>No Class Info Available</Alert.Heading>
        <hr />
        You will be registered for an in-person training class after your online
        training is complete. Complete your training here:{" "}
        <a
          href="https://captivateprime.adobe.com/ocrov"
          alt="CSR Online Training"
        >
          Online Training
        </a>
      </Alert>
    );
  }

  renderContent() {
    if (this.props.training) {
      const { rows } = this.props.training;
      if (!Array.isArray(rows)) {
        return <ErrorModal />;
      } else if (rows.length === 0) {
        return (
          <Alert variant="info">
            <Alert.Heading>No Class Info Available</Alert.Heading>
            <hr />
            You will be registered for an in-person training class after your
            online training is complete. Complete your training here:{" "}
            <a
              href="https://captivateprime.adobe.com/ocrov"
              alt="CSR Online Training"
            >
              Online Training
            </a>
          </Alert>
        );
      } else {
        return this.buildCardDeck(rows);
      }
    }
    return <LoadingAnimation />;
  }

  renderHandbook() {
    return (
      <Container>
        <h3 className="mt-3 mb-3">Training Handbook Information</h3>
        <strong>Training Handbook Online</strong>
        <br />
        <a
          href={process.env.PUBLIC_URL + "/pdfs/2021Recall _SITE_BINDER_FINAL.pdf"}
          alt="Training Handbook PDF"
          target="_blank"
          rel="noreferrer noopener"
        >
          Click here to view the 2021 California Gubernatorial Recall Election Site Binder
        </a>
        <br />
        <a
          href={process.env.PUBLIC_URL + "/pdfs/CACRCL2021_vc_handbook.pdf"}
          alt="Training Handbook PDF"
          target="_blank"
          rel="noreferrer noopener"
        >
          Click here to view the Vote Center Handbook – September 14, 2021
        </a>
        <br />
        <a
          href={process.env.PUBLIC_URL + "/pdfs/Photo_Handbook_final.pdf"}
          alt="Training Handbook PDF"
          target="_blank"
          rel="noreferrer noopener"
        >
          Click here to view the Vote Center Photo Handbook – Supplemental Reference Guide
        </a>
        <br />
		       <br />
        <strong>Training Videos</strong>
        <br />
        <a
          href="https://youtu.be/vKrrXygBpbw"
          alt="Training Video"
          target="_blank"
          rel="noreferrer noopener"
        >
          Vote Center Training Video
        </a>
      </Container>
    );
  }

  renderGeneralInfo() {
    return (
      <Container>
        <h3 className="mt-3 mb-3">In-Person Training Class Info</h3>
        You must complete your training requirement before you can be assigned to a Vote Center. You will receive your Vote Center employee badge
        during your in-person training.
        <br />
        If you have questions related to training, please email&nbsp;
        <a href="mailto:training@ocvote.gov">training@ocvote.gov</a>.
      </Container>
    );
  }

  renderSiteBinder() {
    return (
      <Container>
        <h3 className="mt-3 mb-3">Site Binder</h3>
        Each Vote Center will have a Site Binder specific to the Vote Center. It
        is designed to supplement the CSR training and help provide additional
        guidance and support at your Vote Center. When you arrive for Early Set
        Up, locate the Site Binder in Cart 1 and begin to familiarize yourself
        with the information. Your site will have a site binder specific
        information pertaining to your site.
        <br />
        <a href="https://pass.ocvote.gov/welcome" alt="Site Binder PDF">
          Click here to download a site binder (not specific to your site)
        </a>
        <br />
      </Container>
    );
  }

  renderOnlineTrainingInfo() {
    return (
      <Container>
        <h3 className="mt-3 mb-3">Online Training</h3>
        <Alert variant="danger">
          Training classes are filling up quickly. Please complete your online
          training as soon as possible to secure your spot in an in-person
          training class.{" "}
          <a
            href="https://captivateprime.adobe.com/ocrov"
            alt="Online Training Login"
            target="_blank"
            rel="noreferrer noopener"
          >
            Click here to sign in to your online training portal.
          </a>
        </Alert>
      </Container>
    );
  }

  renderTabs() {
    return (
      <Tabs defaultActiveKey="onlineTraining">
        <Tab eventKey="onlineTraining" title="Online Training">
          {this.renderOnlineTrainingInfo()}
        </Tab>
        <Tab eventKey="info" title="In-Person Training">
          {this.renderGeneralInfo()}
        </Tab>
        {/* <Tab eventKey="siteBinder" title="Site Binder">
          {this.renderSiteBinder()}
        </Tab> */}
        <Tab eventKey="handbook" title="Handbook">
          {this.renderHandbook()}
        </Tab>
        <Tab eventKey="zoom" title="Deep Dive Sessions">
          <ZoomInfo />
        </Tab>
      </Tabs>
    );
  }

  render() {
    const classes = this.renderContent();
    const tabs = this.renderTabs();
    return (
      <Layout title="Training">
        <Row>
          <Col>{tabs}</Col>
        </Row>
        <Row className="mb-3 mt-5">
          <Col>
            <h2>
              <Badge variant="success">
                Welcome {`${this.props.auth.name.split(" ")[0]}!` || "!"}
              </Badge>
            </h2>
          </Col>
        </Row>
        <hr className="w-50 mb-5 mt-5" />
        <Row>
          <Col>
            <h2>Your Training Classes</h2>
            <br />
            {classes}
          </Col>
        </Row>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return { training: state.empData.training, auth: state.auth };
};

export default connect(mapStateToProps, { getTraining })(Training);
